<template>
  <asc-role-dialog-grid-wrapper
    :title="title"
    :values="values"
    :grid-columns="gridColumns"
    :grid-filters="gridFilters"
    :on-open="onOpen"
    :all-resource-modules="allResourceModules"
    v-on="$listeners"
  ></asc-role-dialog-grid-wrapper>
</template>

<script>
import AscRoleDialogGridWrapper from '@/components/organisms/AscRoleDialogGridWrapper'
import { AscGridPropsMixin } from '@/components/mixins'

export default {
  name: 'AscRoleDialogGridTemplate',

  components: {
    AscRoleDialogGridWrapper,
  },

  mixins: [AscGridPropsMixin],

  props: {
    allResourceModules: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
